export const DEFAULT_KATEGORI = [
  'Paint Protection Film',
  'Bahan Kimia',
  'Peralatan',
  'Perlengkapan',
  'Suku Cadang',
  'Lainnya',
]
